/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ActivateConnectionCodeRequest,
  CheckCodeRequest,
  CommandPrefab,
  CreateCommandPrefabRequest,
  GrantCommandPrefabRequest,
  ModifyAccessLevelRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type grantedUsersGetConnectionCodeResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetConnectionCodeResponseSuccess = (grantedUsersGetConnectionCodeResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetConnectionCodeResponse = (grantedUsersGetConnectionCodeResponseSuccess)

export const getGrantedUsersGetConnectionCodeUrl = (uuid: string,) => {




  return `/api/GrantedUsers/ConnectionCode/${uuid}`
}

export const useGrantedUsersGetConnectionCodeHook = (): (uuid: string, options?: RequestInit) => Promise<grantedUsersGetConnectionCodeResponse> => {

      const customFetcher = useSfetchMutator();
      return (uuid: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetConnectionCodeUrl(uuid),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersActivateConnectionCodeResponse200 = {
  data: void
  status: 200
}

export type grantedUsersActivateConnectionCodeResponseSuccess = (grantedUsersActivateConnectionCodeResponse200) & {
  headers: Headers;
};
;

export type grantedUsersActivateConnectionCodeResponse = (grantedUsersActivateConnectionCodeResponseSuccess)

export const getGrantedUsersActivateConnectionCodeUrl = () => {




  return `/api/GrantedUsers/ActivateConnectionCode`
}

export const useGrantedUsersActivateConnectionCodeHook = (): (activateConnectionCodeRequest?: ActivateConnectionCodeRequest, options?: RequestInit) => Promise<grantedUsersActivateConnectionCodeResponse> => {

      const customFetcher = useSfetchMutator();
      return (activateConnectionCodeRequest?: ActivateConnectionCodeRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersActivateConnectionCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateConnectionCodeRequest)
  }
);
      }
  }


export type grantedUsersCheckCodeResponse200 = {
  data: void
  status: 200
}

export type grantedUsersCheckCodeResponseSuccess = (grantedUsersCheckCodeResponse200) & {
  headers: Headers;
};
;

export type grantedUsersCheckCodeResponse = (grantedUsersCheckCodeResponseSuccess)

export const getGrantedUsersCheckCodeUrl = () => {




  return `/api/GrantedUsers/CheckCode`
}

export const useGrantedUsersCheckCodeHook = (): (checkCodeRequest?: CheckCodeRequest, options?: RequestInit) => Promise<grantedUsersCheckCodeResponse> => {

      const customFetcher = useSfetchMutator();
      return (checkCodeRequest?: CheckCodeRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersCheckCodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkCodeRequest)
  }
);
      }
  }


export type grantedUsersGrantAccountResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGrantAccountResponseSuccess = (grantedUsersGrantAccountResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGrantAccountResponse = (grantedUsersGrantAccountResponseSuccess)

export const getGrantedUsersGrantAccountUrl = (username: string,) => {




  return `/api/GrantedUsers/GrantAccount/${username}`
}

export const useGrantedUsersGrantAccountHook = (): (username: string, options?: RequestInit) => Promise<grantedUsersGrantAccountResponse> => {

      const customFetcher = useSfetchMutator();
      return (username: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGrantAccountUrl(username),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type grantedUsersRevokeAccountResponse200 = {
  data: void
  status: 200
}

export type grantedUsersRevokeAccountResponseSuccess = (grantedUsersRevokeAccountResponse200) & {
  headers: Headers;
};
;

export type grantedUsersRevokeAccountResponse = (grantedUsersRevokeAccountResponseSuccess)

export const getGrantedUsersRevokeAccountUrl = (grantId: string,) => {




  return `/api/GrantedUsers/RevokeAccount/${grantId}`
}

export const useGrantedUsersRevokeAccountHook = (): (grantId: string, options?: RequestInit) => Promise<grantedUsersRevokeAccountResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantId: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersRevokeAccountUrl(grantId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type grantedUsersGetGrantedAccountsResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetGrantedAccountsResponseSuccess = (grantedUsersGetGrantedAccountsResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetGrantedAccountsResponse = (grantedUsersGetGrantedAccountsResponseSuccess)

export const getGrantedUsersGetGrantedAccountsUrl = () => {




  return `/api/GrantedUsers/GetGrantedAccounts`
}

export const useGrantedUsersGetGrantedAccountsHook = (): ( options?: RequestInit) => Promise<grantedUsersGetGrantedAccountsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetGrantedAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersGrantCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGrantCommandPrefabResponseSuccess = (grantedUsersGrantCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGrantCommandPrefabResponse = (grantedUsersGrantCommandPrefabResponseSuccess)

export const getGrantedUsersGrantCommandPrefabUrl = () => {




  return `/api/GrantedUsers/GrantCommandPrefab`
}

export const useGrantedUsersGrantCommandPrefabHook = (): (grantCommandPrefabRequest?: GrantCommandPrefabRequest, options?: RequestInit) => Promise<grantedUsersGrantCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantCommandPrefabRequest?: GrantCommandPrefabRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGrantCommandPrefabUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantCommandPrefabRequest)
  }
);
      }
  }


export type grantedUsersRevokeCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersRevokeCommandPrefabResponseSuccess = (grantedUsersRevokeCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersRevokeCommandPrefabResponse = (grantedUsersRevokeCommandPrefabResponseSuccess)

export const getGrantedUsersRevokeCommandPrefabUrl = () => {




  return `/api/GrantedUsers/RevokeCommandPrefab`
}

export const useGrantedUsersRevokeCommandPrefabHook = (): (grantCommandPrefabRequest?: GrantCommandPrefabRequest, options?: RequestInit) => Promise<grantedUsersRevokeCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantCommandPrefabRequest?: GrantCommandPrefabRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersRevokeCommandPrefabUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantCommandPrefabRequest)
  }
);
      }
  }


export type grantedUsersGetCommandPrefabsResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetCommandPrefabsResponseSuccess = (grantedUsersGetCommandPrefabsResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetCommandPrefabsResponse = (grantedUsersGetCommandPrefabsResponseSuccess)

export const getGrantedUsersGetCommandPrefabsUrl = () => {




  return `/api/GrantedUsers/GetCommandPrefabs`
}

export const useGrantedUsersGetCommandPrefabsHook = (): ( options?: RequestInit) => Promise<grantedUsersGetCommandPrefabsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetCommandPrefabsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersGetCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetCommandPrefabResponseSuccess = (grantedUsersGetCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetCommandPrefabResponse = (grantedUsersGetCommandPrefabResponseSuccess)

export const getGrantedUsersGetCommandPrefabUrl = (id: string,) => {




  return `/api/GrantedUsers/CommandPrefab/${id}`
}

export const useGrantedUsersGetCommandPrefabHook = (): (id: string, options?: RequestInit) => Promise<grantedUsersGetCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetCommandPrefabUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersUpdateCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersUpdateCommandPrefabResponseSuccess = (grantedUsersUpdateCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersUpdateCommandPrefabResponse = (grantedUsersUpdateCommandPrefabResponseSuccess)

export const getGrantedUsersUpdateCommandPrefabUrl = () => {




  return `/api/GrantedUsers/CommandPrefab`
}

export const useGrantedUsersUpdateCommandPrefabHook = (): (commandPrefab?: CommandPrefab, options?: RequestInit) => Promise<grantedUsersUpdateCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (commandPrefab?: CommandPrefab, options?: RequestInit) => {

        return customFetcher(getGrantedUsersUpdateCommandPrefabUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(commandPrefab)
  }
);
      }
  }


export type grantedUsersGetCommandPrefabsForBotResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetCommandPrefabsForBotResponseSuccess = (grantedUsersGetCommandPrefabsForBotResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetCommandPrefabsForBotResponse = (grantedUsersGetCommandPrefabsForBotResponseSuccess)

export const getGrantedUsersGetCommandPrefabsForBotUrl = (botId: string,) => {




  return `/api/GrantedUsers/GetGrantedCommandPrefabsForBot/${botId}`
}

export const useGrantedUsersGetCommandPrefabsForBotHook = (): (botId: string, options?: RequestInit) => Promise<grantedUsersGetCommandPrefabsForBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetCommandPrefabsForBotUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersGetCommandPrefabsInGrantResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetCommandPrefabsInGrantResponseSuccess = (grantedUsersGetCommandPrefabsInGrantResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetCommandPrefabsInGrantResponse = (grantedUsersGetCommandPrefabsInGrantResponseSuccess)

export const getGrantedUsersGetCommandPrefabsInGrantUrl = (grantId: string,) => {




  return `/api/GrantedUsers/GetCommandPrefabsInGrant/${grantId}`
}

export const useGrantedUsersGetCommandPrefabsInGrantHook = (): (grantId: string, options?: RequestInit) => Promise<grantedUsersGetCommandPrefabsInGrantResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantId: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetCommandPrefabsInGrantUrl(grantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersCreateCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersCreateCommandPrefabResponseSuccess = (grantedUsersCreateCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersCreateCommandPrefabResponse = (grantedUsersCreateCommandPrefabResponseSuccess)

export const getGrantedUsersCreateCommandPrefabUrl = () => {




  return `/api/GrantedUsers/CreateCommandPrefab`
}

export const useGrantedUsersCreateCommandPrefabHook = (): (createCommandPrefabRequest?: CreateCommandPrefabRequest, options?: RequestInit) => Promise<grantedUsersCreateCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (createCommandPrefabRequest?: CreateCommandPrefabRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersCreateCommandPrefabUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCommandPrefabRequest)
  }
);
      }
  }


export type grantedUsersDeleteCommandPrefabResponse200 = {
  data: void
  status: 200
}

export type grantedUsersDeleteCommandPrefabResponseSuccess = (grantedUsersDeleteCommandPrefabResponse200) & {
  headers: Headers;
};
;

export type grantedUsersDeleteCommandPrefabResponse = (grantedUsersDeleteCommandPrefabResponseSuccess)

export const getGrantedUsersDeleteCommandPrefabUrl = (id: string,) => {




  return `/api/GrantedUsers/DeleteCommandPrefab/${id}`
}

export const useGrantedUsersDeleteCommandPrefabHook = (): (id: string, options?: RequestInit) => Promise<grantedUsersDeleteCommandPrefabResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersDeleteCommandPrefabUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type grantedUsersGetMyBotsResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetMyBotsResponseSuccess = (grantedUsersGetMyBotsResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetMyBotsResponse = (grantedUsersGetMyBotsResponseSuccess)

export const getGrantedUsersGetMyBotsUrl = () => {




  return `/api/GrantedUsers/GetMyBots`
}

export const useGrantedUsersGetMyBotsHook = (): ( options?: RequestInit) => Promise<grantedUsersGetMyBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetMyBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersGetNameOfBotResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetNameOfBotResponseSuccess = (grantedUsersGetNameOfBotResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetNameOfBotResponse = (grantedUsersGetNameOfBotResponseSuccess)

export const getGrantedUsersGetNameOfBotUrl = (botId: string,) => {




  return `/api/GrantedUsers/GetNameOfBot/${botId}`
}

export const useGrantedUsersGetNameOfBotHook = (): (botId: string, options?: RequestInit) => Promise<grantedUsersGetNameOfBotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetNameOfBotUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersModifyAccessLevelResponse200 = {
  data: void
  status: 200
}

export type grantedUsersModifyAccessLevelResponseSuccess = (grantedUsersModifyAccessLevelResponse200) & {
  headers: Headers;
};
;

export type grantedUsersModifyAccessLevelResponse = (grantedUsersModifyAccessLevelResponseSuccess)

export const getGrantedUsersModifyAccessLevelUrl = () => {




  return `/api/GrantedUsers/ModifyAccessLevel`
}

export const useGrantedUsersModifyAccessLevelHook = (): (modifyAccessLevelRequest?: ModifyAccessLevelRequest, options?: RequestInit) => Promise<grantedUsersModifyAccessLevelResponse> => {

      const customFetcher = useSfetchMutator();
      return (modifyAccessLevelRequest?: ModifyAccessLevelRequest, options?: RequestInit) => {

        return customFetcher(getGrantedUsersModifyAccessLevelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(modifyAccessLevelRequest)
  }
);
      }
  }


export type grantedUsersGetAllActiveBotsResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetAllActiveBotsResponseSuccess = (grantedUsersGetAllActiveBotsResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetAllActiveBotsResponse = (grantedUsersGetAllActiveBotsResponseSuccess)

export const getGrantedUsersGetAllActiveBotsUrl = () => {




  return `/api/GrantedUsers/GetAllActiveBots`
}

export const useGrantedUsersGetAllActiveBotsHook = (): ( options?: RequestInit) => Promise<grantedUsersGetAllActiveBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetAllActiveBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantedUsersGetGrantedBotsResponse200 = {
  data: void
  status: 200
}

export type grantedUsersGetGrantedBotsResponseSuccess = (grantedUsersGetGrantedBotsResponse200) & {
  headers: Headers;
};
;

export type grantedUsersGetGrantedBotsResponse = (grantedUsersGetGrantedBotsResponseSuccess)

export const getGrantedUsersGetGrantedBotsUrl = () => {




  return `/api/GrantedUsers/GetGrantedBots`
}

export const useGrantedUsersGetGrantedBotsHook = (): ( options?: RequestInit) => Promise<grantedUsersGetGrantedBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantedUsersGetGrantedBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


